import {
  selectDeltaFees,
  selectDeltaTax,
  selectEndorsementIssueBlockReason,
  selectPremiumDelta,
  useEndorsementSelector,
} from "@redux/slices/endorsement";
import { useParams } from "react-router";
import { getIssueEndorsementMessage } from "../issueEndorsementMessages";
import { useEffect, useMemo, useRef } from "react";
import { useConflictingEndorsements } from "../useConflictingEndorsements";

export const useCheckoutStep = () => {
  const { policyLocator = "" } = useParams();
  const endorsementIssueBlockReason = useEndorsementSelector(
    selectEndorsementIssueBlockReason
  );
  const errorMessage = getIssueEndorsementMessage(endorsementIssueBlockReason);
  const errorRef = useRef<HTMLDivElement>(null);
  const premiumDelta = useEndorsementSelector(selectPremiumDelta);
  const deltaFees = useEndorsementSelector(selectDeltaFees);
  const deltaTax = useEndorsementSelector(selectDeltaTax);

  const totalChange = useMemo(
    () => (premiumDelta ?? 0) + (deltaTax ?? 0) + (deltaFees ?? 0),
    [premiumDelta, deltaFees, deltaTax]
  );

  useEffect(() => {
    errorRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  }, [endorsementIssueBlockReason]);

  const { isOpen, closeModal, saveAndExit, discardConflicting } =
    useConflictingEndorsements();

  return {
    policyLocator,
    errorMessage,
    errorRef,
    totalChange,
    isOpen,
    closeModal,
    saveAndExit,
    discardConflicting,
  };
};
